import React from 'react';
import './Kindergarten.css';

const Kindergarten: React.FC = () => {
  return (
    <section className="kindergarten" id="about">
      <div className="container">
        <div className="kindergarten-content">
          <div className="kindergarten-text">
            <h2>About Our Kindergarten</h2>
            <p>New ABC Montessori School has been established in the
                heart of lucknow since 2009. The primary focus of the
                Montessori system of education is to treat each child as
                a unique individual. This allows children to learn as their
                own pace.
                The Montessori model is so very different from traditional
                education in its celebration of each child’s unique potential
                and it depends on a culture of partnership & trust, rather
                than punishments. Children are born intelligent, curious,
                relative & filled with sense of wonder. Schools like Montessori
                seeks to cultivate & nurture each child human spirit,
                while instilling a lifelong love of learning & passion for
                excellence. The goal of Montessori graduates are similar to
                conventional schools, but the experience of getting their
                is so much more pleasant & stress free for children, parents
                & educators.
              </p>
            {/* <button className="tour-button">Virtual Tour</button> */}
          </div>
          <div className="kindergarten-image">
            <div className="kindergarten-placeholder">
              <img className="building-icon" src="/images/about-us/school-img.jpg" alt="" style={{ width: '100%', height: 'auto', borderRadius: '20px'}} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Kindergarten;
